import PropTypes from "prop-types";
import { useState } from "react";
import {
  Snackbar,
  Alert,
  TextField,
  Box,
  InputAdornment,
  Icon,
  Typography,
} from "@mui/material";

function ShortTextField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");
  // console.log(options);

  return (
    <Box>
      <Box ml={0.5}>
        <Typography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </Typography>
      </Box>
      <TextField
        id={`dff_${fieldRef}`}
        name={fieldRef}
        margin="dense"
        // label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>edit_note</Icon>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          sx: {
            whiteSpace: 'break-spaces',
          },
        }}
        onBlur={(e) => {
          const entryValue = e.target.value;
          // console.log(options);

          if (typeof options.number_only !== "undefined") {
            if (options.number_only === "true" || options.number_only === "1") {
              const isnum = /^\d+$/.test(entryValue);
              if (!isnum) {
                e.target.value = null;
                setErrMsg(`${displayName} requires only digits`);
                showFieldError(true);
                return;
              }
            }
          }

          if (typeof options.min_length !== "undefined") {
            if (entryValue.length < options.min_length) {
              e.target.value = null;
              setErrMsg(
                `${displayName} must be atleast ${options.min_length} long`
              );
              showFieldError(true);
              return;
            }
          }

          if (typeof options.max_length !== "undefined") {
            if (entryValue.length > options.max_length) {
              e.target.value = null;
              setErrMsg(
                `${displayName} cannot be longer ${options.max_length} characters`
              );
              showFieldError(true);
              return;
            }
          }

          if (typeof options.allowed_length !== "undefined") {
            if (entryValue.length !== options.allowed_length) {
              e.target.value = null;
              setErrMsg(
                `${displayName} must be ${options.allowed_length} long`
              );
              showFieldError(true);
            }
          }
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
}

// Typechecking props of the Transaction
ShortTextField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

ShortTextField.defaultProps = {
  options: null,
};

export default ShortTextField;
